/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

//Toggles the loader
export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

//sets the selected input to the redux store
export const setSearchInput = (data) => {
  return {
    type: ActionTypes.SET_SELECTED_INPUT,
    payload: data,
  };
};

//set the request screen frod api data to store
export const setRequestScreenGrid = (data) => ({
  type: ActionTypes.SET_REQUEST_SCREEN_GRID,
  payload: data,
});

// sets the geader grid data from API to redux store
export const setHeaderGridData = (data) => ({
  type: ActionTypes.SET_HEADER_GRID,
  payload: data,
});

// sets the right grid data of detail screen
export const setRightGridData = (data) => ({
  type: ActionTypes.SET_RIGHT_GRID_DATA,
  payload: data,
});

//Refreshed the Store State
export const refreshQuarterlyClaimReconcilliationSate = () => ({
  type: ActionTypes.REFRESH_QUAERTERLY_CLAIMS_RECONCILLIATION,
  payload: {},
});

//set data for export all for left tabel data
export const setLeftGridDataForAll = (data, rebateProgram) => ({
  type: ActionTypes.SET_LEFT_GRID_DATA_FOR_ALL,
  payload: data,
  rebateProgram,
});

//set data for export all for right tabel data
export const setRightGridDataForAll = (data, rebateProgram) => ({
  type: ActionTypes.SET_RIGHT_GRID_DATA_FOR_ALL,
  payload: data,
  rebateProgram,
});
// sets the left grid data of detail screen
export const setLeftGridData = (data) => ({
  type: ActionTypes.SET_LEFT_GRID_DATA,
  payload: data,
});

//sets selected input value from first screen to detail screen to the redux store
export const selectedRequest = (data) => ({
  type: ActionTypes.SET_SELECTED_REQUEST,
  payload: data,
});

//set Last Updated Userid And Count API data
export const setLastUpdatedUseridAndCount = (data) => ({
  type: ActionTypes.SET_LAST_UPDATED_USERID_AND_COUNT,
  payload: data,
});

// set schedule meesgae data from API to redux store
export const setScheduleMessage = (data) => ({
  type: ActionTypes.SET_SCHEDULE_MESSAGE,
  payload: data,
});

// API to get Request Screen Gridr Reports data
export const getRequestScreenGrid = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_REQUEST_SCREEN_GRID, {})
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setRequestScreenGrid(
          response?.data?.quarterlyClaimsReconciliationRequestScreenGridVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRequestScreenGrid([]));
    });
};

// API to get Table Header Grid Reports data
export const getTableHeaderGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_HEADER_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setHeaderGridData(
          response?.data?.quarterlyClaimsReconciliationHeaderGridVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setHeaderGridData([]));
    });
};

// API to  get display screenleft grid data
export const getDisplayScreenLeftGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_DISPLAY_SCREEN_LEFT_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setLeftGridData(
          response?.data?.quarterlyClaimsReconciliationDisplayScreenLeftGridVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setLeftGridData([]));
    });
};
// API to  get display screenleft grid data
export const getDisplayScreenRightGrid = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_DISPLAY_SCREEN_RIGHT_GRID, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setRightGridData(
          response?.data?.quarterlyClaimsReconciliationDisplayScreenRightGridVO
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setRightGridData([]));
    });
};

// API to  get display screenleft grid data for all export
export const getDisplayScreenLeftGridForAll =
  (values, rebateProgram) => (dispatch) => {
    dispatch(setLoading(true));
    axios
      .post(serviceEndPoint.GET_DISPLAY_SCREEN_LEFT_GRID, values)
      .then((response) => {
        dispatch(setLoading(false));

        dispatch(
          setLeftGridDataForAll(
            response?.data
              ?.quarterlyClaimsReconciliationDisplayScreenLeftGridVO,
            rebateProgram
          )
        );
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch(setLeftGridDataForAll([], rebateProgram));
      });
  };
// API to  get display screenleft grid data for all export
export const getDisplayScreenRightGridForAll =
  (values, rebateProgram) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_DISPLAY_SCREEN_RIGHT_GRID, values)
      .then((response) => {
        dispatch(setLoading(false));

        dispatch(
          setRightGridDataForAll(
            response?.data
              ?.quarterlyClaimsReconciliationDisplayScreenRightGridVO,
            rebateProgram
          )
        );
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch(setRightGridDataForAll([], rebateProgram));
      });
  };
// API to  ge tLast Updated Userid And Count
export const getLastUpdatedUseridAndCount = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_LAST_UPDATED_USERID_AND_COUNT, values)
    .then((response) => {
      dispatch(setLoading(false));

      dispatch(
        setLastUpdatedUseridAndCount(
          response?.data?.quarterlyClaimsReconciliationLastUpdatedUserCountVO ||
            'NoRequestExist'
        )
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setLastUpdatedUseridAndCount(null));
    });
};
// API to get Quarterly Claims Reconciliation Shedule
export const getQuarterlyClaimsReconciliationShedule =
  (values) => (dispatch) => {
    dispatch(setLoading(true));
    return axios
      .post(serviceEndPoint.GET_QUARTERLY_CLAIMS_RECONCILIATION_SHEDULE, values)
      .then((response) => {
        dispatch(setLoading(false));

        dispatch(
          setScheduleMessage(
            response?.data?.quarterlyClaimsReconciliationSchedule
          )
        );
      })
      .catch((response) => {
        dispatch(setLoading(false));
        dispatch(setScheduleMessage(null));
      });
  };
export const exportAllPDF =
  ({ input, allRebates }) =>
  (dispatch) => {
    if (allRebates?.length > 0) {
      for (let i = 0; i < allRebates.length; i++) {
        const inputValue = {
          ...input,
          rebateProgramCd: allRebates[i].rebateProgramCd,
        };
        dispatch(
          getDisplayScreenRightGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
        dispatch(
          getDisplayScreenLeftGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
      }
    }
  };
// API to export all data for Excel (similar to exportAllPDF)
export const exportAllExcel =
  ({ input, allRebates }) =>
  (dispatch) => {
    if (allRebates?.length > 0) {
      for (let i = 0; i < allRebates.length; i++) {
        const inputValue = {
          ...input,
          rebateProgramCd: allRebates[i].rebateProgramCd,
        };
        dispatch(
          getDisplayScreenRightGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
        dispatch(
          getDisplayScreenLeftGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
      }
    }
  };
export const exportAllLEFTExcel =
  ({ input, allRebates }) =>
  (dispatch) => {
    if (allRebates?.length > 0) {
      for (let i = 0; i < allRebates.length; i++) {
        const inputValue = {
          ...input,
          rebateProgramCd: allRebates[i].rebateProgramCd,
        };
        dispatch(
          getDisplayScreenRightGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
        dispatch(
          getDisplayScreenLeftGridForAll(
            inputValue,
            allRebates[i].rebateProgramCd
          )
        );
      }
    }
  };
